import { StorageKeys } from "@origin-digital/platform-enums";

const STORAGE_VERSION: string = "2.0";

interface StorageData {
  version: string;
  allSelected: boolean;
  selectedProperty: string | undefined;
  selectedServices: Record<string, string>;
}

export const createStorageData = (): StorageData => ({
  version: STORAGE_VERSION,
  allSelected: false,
  selectedProperty: undefined,
  selectedServices: {},
});

const storage = (): Storage => window.localStorage;
const storageKey = StorageKeys.selectedProperty;

/**
 * Retrieves stored selection data.
 * If storage data version is not current, then clears the storage.
 */
export const readDataFromStorage = (): StorageData | undefined => {
  const json = storage().getItem(storageKey);
  if (!json) {
    return undefined;
  }
  const data = JSON.parse(json) as StorageData;
  if (data?.version !== STORAGE_VERSION) {
    storage().removeItem(storageKey);
    return undefined;
  }
  return data;
};

/**
 * Update stored selection data.
 * If storage data version is not current, then clears the storage.
 */
export const writePropertySelectionToStorage = (propertyId: string | null) => {
  const data = readDataFromStorage() ?? createStorageData();
  if (propertyId === null) {
    data.allSelected = true;
  } else {
    data.allSelected = false;
    data.selectedProperty = propertyId;
  }
  try {
    storage().setItem(storageKey, JSON.stringify(data));
  } catch (error) {
    // swallow error to allow app to function without storage
  }
};

/**
 * Update stored selection data.
 * If storage data version is not current, then clears the storage.
 */
export const writeServiceSelectionToStorage = (
  propertyId: string,
  serviceIdentifier: string
) => {
  const data = readDataFromStorage() ?? createStorageData();
  data.selectedServices[propertyId] = serviceIdentifier;
  try {
    storage().setItem(storageKey, JSON.stringify(data));
  } catch (error) {
    // swallow error to allow app to function without storage
  }
};
